import { PrimaryDocumentCategories } from "../types/document";
import { OnBoardStep } from "../types/onboard";

export const BASEURL = import.meta.env.VITE_BASE_URL;

export function BlobToBase64(
  image: Blob,
  callback: (base64String: string | ArrayBuffer | null) => void
) {
  const reader = new FileReader();

  reader.onloadend = function () {
    callback(reader.result); // This is the base64-encoded string
  };

  reader.readAsDataURL(image);
}

export const convertBlobToBase64 = (blob: Blob): Promise<string> => {
  return new Promise((resolve,reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result as string);
    reader.onerror = () => reject(new Error("Error reading file"));
    reader.readAsDataURL(blob);
  });
};

// Resize image using Canvas if it's more than 5MB
export const resizeBlob = (blob: Blob, maxSizeBytes: number): Promise<string> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        
        reader.onload = (event) => {
            const img = document.createElement('img');
            img.src = event.target?.result as string;

            img.onload = () => {
                const canvas = document.createElement("canvas");
                const ctx = canvas.getContext("2d");

                if (!ctx) {
                    return reject(new Error("Canvas context not available"));
                }

                let width = img.width;
                let height = img.height;

                // Calculate scale factor
                const scaleFactor = Math.sqrt(maxSizeBytes / blob.size);
                canvas.width = width * scaleFactor;
                canvas.height = height * scaleFactor;

                ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

                // Convert resized image to Blob and then Base64
                canvas.toBlob(
                    (resizedBlob) => {
                        if (!resizedBlob) {
                            return reject(new Error("Failed to resize image"));
                        }
                        convertBlobToBase64(resizedBlob).then(resolve).catch(reject);
                    },
                    "image/jpeg", 
                    0.8 // quality as needed
                );
            };
            img.onerror = () => reject(new Error("Error loading image"));
        };
        reader.onerror = () => reject(new Error("Error reading file"));
    });
};
/**
 * The steps shown in the progress tracker, each tagged with the flow step it
 * stands for.
 *
 * The tag is what makes the tracker survive a skipped step. The secondary
 * document is dropped from this list when the client has not enabled it, so a
 * position in the rendered list stops lining up with the OnBoardStep numbering —
 * and matching on the tag keeps the highlight on the step the applicant is
 * actually on instead of on whatever now sits at that index.
 *
 * The old `imageSrc` on each entry is gone: it fed the image-or-number marker in
 * the component StepTracker replaced, and nothing has read it since.
 */
export const onboardSteps: Array<{ step: OnBoardStep; description: string }> = [
  { step: OnBoardStep.DOCUMENT_CAPTURE, description: 'onboardstep.primarydocument' },
  { step: OnBoardStep.SECONDARY_DOCUMENT_CAPTURE, description: 'onboardstep.secondarydocument' },
  { step: OnBoardStep.SMILE_LIVENESS, description: 'onboardstep.selfie' },
  { step: OnBoardStep.RESULTS, description: 'onboardstep.reviewandsubmit' },
];


export const getUserDevice = () => {
    const pattern = /Mobi|Android|iPhone|iPad|iPod|Windows Phone/i;
    if(pattern.test(navigator.userAgent)){
      return "MOBILE";
    }
    return "DESKTOP"
  };

   export const primaryDocumentOptions = [
    { value: PrimaryDocumentCategories.PASSPORT, label: "primarydocument.select.option1" },
    {
      value: PrimaryDocumentCategories.DRIVING_LICENSE,
      label: "primarydocument.select.option2",
    },
    {
      value: PrimaryDocumentCategories.PERMANENT_RESIDENT_CARD,
      label: "primarydocument.select.option3",
    },
    {
      value: PrimaryDocumentCategories.GENERAL_IDENTIFICATION_CARD,
      label: "primarydocument.select.option4",
    },
  ];